<form class="govuk-form-group" [formGroup]="form" (ngSubmit)="submit()">
  <label class="govuk-label" for="email">
    Email Address
  </label>
  <input class="govuk-input" id="email" name="email" type="text" formControlName="email" [readonly]="progress">

  <div class="govuk-!-margin-top-5 inline-button">
    <button *ngIf="!sent" type="submit" class="govuk-button theme-button" [disabled]="!form.valid || progress">
      Send
    </button>
    <span class="fa fa-spinner fa-spin fa-fw" *ngIf="progress"></span>
  </div>

  <p class="govuk-body-s" *ngIf="feedback">{{feedback}}</p>
</form>
